/**
 * Users module
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { UserPresenter } from '@app/modules/users/user-presenter';
import { createSelectDirective } from '@shared/directives/inputs/abstract-select/abstract-select-directive';
import { CurrentUser } from '../users/current-user';
import { UserRestoreDialogController } from '../users/restore/user-restore-dialog-controller';
import UserPreviewDialogController from './controllers/user-preview-dialog-controller';
import userChipsDirective from './directives/user-chips-directive';
import { userSelectDirective } from './select/user-select-directive';
import { userFetcherProvider } from './user-fetcher';

// Create the module
export const UsersModule = angular.module('carelinelive.users', ['carelinelive.dialogs', 'ui.router']);

// Config
UsersModule.config(usersModuleConfig);
UsersModule.run(usersModuleRun);

// Directives
UsersModule.directive('userChips', userChipsDirective);
UsersModule.directive('userSelect', userSelectDirective);

UsersModule.directive(
    'usersMultiSelect',
    createSelectDirective({
        multiple: true,
        $presenter: UserPresenter,
        fetcherName: '$userFetcher',
        metaTemplate: `
        {{ option.email }}
    `
    })
);

// Providers
UsersModule.provider('$userFetcher', userFetcherProvider as any);

// Run
usersModuleRun.$inject = ['$injector'];

function usersModuleRun($injector) {
    $injector.invoke(CurrentUser.init);
}

/**
 * The users module config.
 */
usersModuleConfig.$inject = ['$appDialogsProvider'];

function usersModuleConfig($appDialogsProvider) {
    $appDialogsProvider.registerDialog('previewUser', function previewUserDialog($event, user) {
        return {
            permissions: 'users_view',
            controller: UserPreviewDialogController,
            template: require('./templates/preview-dialog.html'),
            targetEvent: $event,
            locals: {
                user
            }
        };
    });

    $appDialogsProvider.registerDialog('confirmRestoreUser', function($event, existingUser) {
        console.log({ existingUser });
        return {
            permissions: 'users_create',
            controller: UserRestoreDialogController,
            template: require('./restore/user-restore-dialog.html'),
            multiple: true,
            targetEvent: $event,
            locals: {
                existingUser
            }
        };
    });
}

// Exports
